import { initialState } from ".";
import {
	SET_SESSION_DATA,
	LOGIN_REQUEST_START,
	LOGIN_REQUEST_FAIL,
	LOGIN_REQUEST_SUCCESS,
	SIGNUP_REQUEST_START,
	SIGNUP_REQUEST_FAIL,
	SIGNUP_REQUEST_SUCCESS,
	CURRENT_USER_REQUEST_FAIL,
	CURRENT_USER_REQUEST_START,
	CURRENT_USER_REQUEST_SUCCESS,
	LOGOUT,
	CHANGE_ADDRESSES_REQUEST_START,
	CHANGE_ADDRESSES_REQUEST_FAIL,
	CHANGE_ADDRESS_REQUEST_SUCCESS,
	UPDATE_PROFILE_START,
	UPDATE_PROFILE_FAIL,
	UPDATE_PROFILE_SUCCESS,
	REQUEST_PASSWORD_RESET_START,
	REQUEST_PASSWORD_RESET_FAIL,
	REQUEST_PASSWORD_RESET_SUCCESS,
	PASSWORD_RESET_SUCCESS,
	PASSWORD_RESET_FAIL,
	PASSWORD_RESET_START
} from "../actions/session";
import { CREATE_SHOP_SUCCESS } from "../actions/shop";

export default function (session = initialState.session, action) {
	switch (action.type) {
		case SET_SESSION_DATA:
			// Set the data, excluding some reserved values, such as user.
			const { user, ...data } = action.data;
			return {
				...session,
				...data
			}
		case PASSWORD_RESET_START:
		case REQUEST_PASSWORD_RESET_START:
		case SIGNUP_REQUEST_START:
		case CURRENT_USER_REQUEST_START:
		case LOGIN_REQUEST_START:
			return {
				...session,
				loginError: null,
				loading: true
			}
		case CURRENT_USER_REQUEST_SUCCESS:
			return {
				...session,
				loading: false,
				loginError: null,
				user: action.user,
				ready: true
			}

		case PASSWORD_RESET_SUCCESS:
		case LOGIN_REQUEST_SUCCESS:
			return {
				...session,
				loading: false,
				loginError: null,
				user: action.user,
				token: action.token,
				ready: true
			}

		case REQUEST_PASSWORD_RESET_SUCCESS:
			return {
				...session,
				loginError: null,
				loading: false,
			}

		case PASSWORD_RESET_FAIL:
		case REQUEST_PASSWORD_RESET_FAIL:
			return {
				...session,
				loginError: action.error || "Unknown error.",
				loading: false,
			}
		
		case SIGNUP_REQUEST_FAIL:
		case CURRENT_USER_REQUEST_FAIL:
		case LOGIN_REQUEST_FAIL:
			return {
				...session,
				loginError: action.error || "Unknown error.",
				loading: false,
				ready: true
			}

		case SIGNUP_REQUEST_SUCCESS:
			return {
				...session,
				loading: false,
				loginError: null,
				needsConfirmation: true
			}

		case LOGOUT:
			return {
				...session,
				loading: false,
				loginError: null,
				user: null,
				token: null
			}

		case CHANGE_ADDRESS_REQUEST_SUCCESS:
			return {
				...session,
				user: {
					...session.user,
					loading: false,
					addresses: action.addresses
				}
			}

		case CHANGE_ADDRESSES_REQUEST_START:
		case CHANGE_ADDRESSES_REQUEST_FAIL:
			return session;

		case UPDATE_PROFILE_START:
			return {
				...session,
				user: {
					...session.user,
					loading: true
				}
			}

		case UPDATE_PROFILE_SUCCESS:
			return {
				...session,
				user: {
					...action.user,
					loading: false
				}
			}

		case UPDATE_PROFILE_FAIL:
			return {
				...session,
				user: {
					...session.user,
					loading: false
				}
			}

		case CREATE_SHOP_SUCCESS:
			return {
				...session,
				user: {
					...session.user,
					shop: action.shop.id
				}
			}

		default:
			return session;
	}
}